import { Box, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Radio, RadioGroup, Tab, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import ButtonContained from '../../../Common/ButtonContained';
import CommonTable from '../../../Common/CommonTable';
import CustomPagination from '../../../Common/CommonPagination';
import CommonTextField from '../../../Common/CommonTextField';
import TextLabel from '../../../Common/CommonTextLabel';
import CustomDialog from '../../../Common/CustomDialog';
import { getAppVersion, updateAppVersion } from '../../../../Redux/Actions/action';
import { showLoader } from '../../../../Redux/Slices/loaderSlice';
import ErrorHandler from '../../../../Utils/handler';
import { toast } from 'react-toastify';
import { TabContext, TabList } from '@mui/lab';
import { makeStyles } from 'tss-react/mui';
import DataNotFound from '../../../Common/DataNotFound';
import StyledTableCell from '../../../Common/styledTableCell';
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const useStyles = makeStyles()((theme) => ({
    TabList: {
        "& .Mui-selected": {
            fontWeight: "bold",
        },
    },
    TabDesign: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: "#3E4094",
        minHeight: "40px",
        maxHeight: "50px",
        minWidth: "auto",
        "&.Mui-selected": {
            backgroundColor: theme?.palette?.bgLightWeight?.main,
        },
    }
}))


const AppVersion = () => {
    // ---------- Hook -----------
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const headerList = ["No", "Version", "Edit"];

    // ---------- State ------------
    const [values, setValues] = useState({
        platformType: "",
        isForceUpdate: "",
        version: "",
    });
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [value, setValue] = useState('1');
    const [versionList, setVersionList] = useState();
    const [errors, setErrors] = useState({});

    // ------------ handelChange --------------
    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setValues({});
        setErrors({})
    };

    const validation = () => {
        let errors = {};
        let valid = true;
        if (!values.platformType) {
            errors.platformType = "Please select Platform Type.";
            valid = false;
        }
        if (!values.isForceUpdate) {
            errors.isForceUpdate = "Please select Force Update.";
            valid = false;
        }
        if (!values.version) {
            errors.version = "Please select Version.";
            valid = false;
        }

        setErrors(errors);
        return valid;
    };

    //  ------------- API ----------------
    const _getAppVersion = async () => {
        dispatch(showLoader(true))
        // let body = {
        //     // page: page,
        //     // limit: rowsPerPage
        // }
        const body = value
        try {
            const result = await dispatch(getAppVersion(body));
            const error = ErrorHandler(result);
            if (error) {
                setVersionList([result?.payload?.data?.appVersion]);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _updateversion = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            try {
                let body = {
                    isForceUpdate: values?.isForceUpdate === "True" ? true : false,
                    appVersion: values?.version,
                    // platformType: values?.platformType === "ANDROID" ? 1 : 2,
                    platformType: value, // ANDROID = 1 , IOS = 2
                }
                const result = await dispatch(updateAppVersion(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getAppVersion()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false))
            }
        }
    }

    useEffect(() => {
        _getAppVersion();
    }, [value]);

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>App Version</Typography>
                        {/* <ButtonContained text={'Add Version'} onClick={() => setOpen(true)} /> */}
                    </Box>
                </Grid>


                <TabContext value={value}>
                    <Box mb={1}>
                        <TabList
                            onChange={(e, newValue) => { setValue(newValue); }}
                            aria-label="tabs with icons"
                            className={classes.TabList}
                        >
                            <Tab label={"Android"} value="1" />
                            <Tab label={"IOS"} value="2" />
                        </TabList>
                    </Box>
                </TabContext>


                <Grid item xs={12}>
                    <CommonTable
                        headerList={headerList}
                        minWidth={400}
                    >
                        {versionList?.length > 0 ? versionList?.map((data, index) => (
                            <TableRow key={data?.id}>
                                <StyledTableCell align="center">{(index % 10) + 1 + (1 - 1) * 10}</StyledTableCell>
                                <StyledTableCell align="center">{data?.appVersion}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <IconButton sx={{ padding: 0 }} onClick={() => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setValues({
                                            platformType: data?.platformType === 1 ? "ANDROID" : "IOS",
                                            isForceUpdate: data?.isForceUpdate === true ? "True" : "False",
                                            version: data?.appVersion,
                                        })
                                    }} >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </StyledTableCell>
                            </TableRow>
                        )) :
                            (
                                <TableRow>
                                    <StyledTableCell colSpan={8}>
                                        <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                    </StyledTableCell>
                                </TableRow>
                            )
                        }
                    </CommonTable>
                    {/* {versionList?.length > 0 &&
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={Math.ceil(occupationList?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage} />

                        </Grid>
                    } */}
                </Grid>
                {open && <CustomDialog
                    isOpen={open} handleClose={handleClear} title={isEdit ? 'Update Version' : 'Add Version'} padding={'10px'}
                    width={400}
                    action={
                        <>
                            <ButtonContained
                                text={isEdit ? 'Update Version' : 'Add Version'}
                                onClick={() => _updateversion()}
                                minWidth={'100%'}
                                marginTop={'10px'}
                            />
                        </>}
                >
                    <Grid container spacing={2} xs={12} ml={-1}>
                        {isEdit ? <></> : <Grid item xs={12}>
                            <InputLabel >{"Platform Type"}</InputLabel>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={values?.platformType}
                                    onChange={(e) =>
                                        setValues({
                                            ...values,
                                            platformType: e?.target?.value,
                                        })
                                    }
                                >
                                    <FormControlLabel value="IOS" control={<Radio />} label="IOS" />
                                    <FormControlLabel value="ANDROID" control={<Radio />} label="ANDROID" />
                                </RadioGroup>
                            </FormControl>
                            <TextLabel title={!values?.platformType ? errors.platformType : ""} color="error" />
                        </Grid>}

                        <Grid item xs={12}>
                            <CommonTextField
                                value={values?.version}
                                width={"100%"}
                                text="Version"
                                type="text"
                                onChange={(e) => setValues({ ...values, version: e?.target?.value })}
                                placeholder="Enter a Version"
                                name="version"
                                valid
                            />
                            <TextLabel
                                title={!values?.version ? errors?.version : ""}
                                color="error"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel >{"Force Update"}</InputLabel>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={values?.isForceUpdate}
                                    onChange={(e) =>
                                        setValues({
                                            ...values,
                                            isForceUpdate: e?.target?.value,
                                        })
                                    }
                                >
                                    <FormControlLabel value="True" control={<Radio />} label="True" />
                                    <FormControlLabel value="False" control={<Radio />} label="False" />
                                </RadioGroup>
                            </FormControl>

                            <TextLabel title={!values?.isForceUpdate ? errors.isForceUpdate : ""} color="error" />
                        </Grid>

                    </Grid>
                </CustomDialog>
                }

            </Grid>
        </>
    )
}

export default AppVersion
